import { render, staticRenderFns } from "./DocumentPOS.vue?vue&type=template&id=136fe604&scoped=true"
import script from "./DocumentPOS.vue?vue&type=script&lang=js"
export * from "./DocumentPOS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136fe604",
  null
  
)

export default component.exports